module.exports = __webpack_public_path__ + "static/img/exploit11.2951c032.png";